import { render, staticRenderFns } from "./simulator-remote.vue?vue&type=template&id=7efef75a&scoped=true&"
import script from "./simulator-remote.vue?vue&type=script&lang=js&"
export * from "./simulator-remote.vue?vue&type=script&lang=js&"
import style0 from "./simulator-remote.vue?vue&type=style&index=0&id=7efef75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efef75a",
  null
  
)

export default component.exports